module.exports = __webpack_public_path__ + "static/media/broken_207.0c09385f.jpg";